/**
 * Banner 服务
 */
import { get } from './api';
import { Banner } from '../shared/models/Banner';
import { PaginatedResponse } from '../types/api';

/**
 * 获取 Banner 列表（H5 用户端）
 * 只返回启用状态的 Banner
 */
export async function getBanners(organizationId?: string): Promise<Banner[]> {
  try {
    const params: any = { status: 'PUBLISHED' }; // 只返回启用的 Banner
    if (organizationId) {
      params.organizationId = organizationId;
    }
    
    const response = await get<Banner[]>('/banners', params);
    
    // 后端直接返回数组
    if (Array.isArray(response)) {
      return response;
    }
    
    // 如果返回的是对象格式（兼容）
    if (response && typeof response === 'object') {
      return (response as any).list || [];
    }
    
    return [];
  } catch (error) {
    console.error('获取 Banner 列表失败:', error);
    return []; // H5 端失败不中断，返回空数组
  }
}

